'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionCreditCard = function ActionCreditCard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
  );
};
ActionCreditCard = (0, _pure2.default)(ActionCreditCard);
ActionCreditCard.displayName = 'ActionCreditCard';
ActionCreditCard.muiName = 'SvgIcon';

exports.default = ActionCreditCard;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/credit-card.js
// module id = 2499
// module chunks = 0